"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractChain = void 0;
function extractChain(_ref) {
  let {
    chains,
    id
  } = _ref;
  return chains.find(chain => chain.id === id);
}
exports.extractChain = extractChain;
//# sourceMappingURL=extractChain.js.map